/*申请开票 */
import { $http, buildHeaders } from "./index";

//获取开票申请列表
export const invoiceapply_list = (params) => {
  return $http.get("/admin/InvoiceApply/index", { params });
};

//获取开票申请详情
export const invoiceapply_detail = (id) => {
  return $http.get("/admin/InvoiceApply/read?id=" + id, {
    headers: buildHeaders(3, "数据加载中，请稍后……"),
  });
};

//获取开票日志
export const invoiceapply_log = (id) => {
  return $http.get("/admin/InvoiceApply/log", {
    params: { limit: 0, invoice_id: id },
  });
};

//添加开票申请
export const invoiceapply_add = (data) => {
  return $http.post("/admin/InvoiceApply/add", data, {
    headers: buildHeaders(3),
  });
};
